import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { EXPERIMENT_FLAG } from '../constants'

// Fires for every arm, control included, so each page enrols all arms alike.
export const useTrackPrcng1270Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(EXPERIMENT_FLAG)
  }, [])
}
